import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasCuentacontable', {
    controller: ContabilidadPolizasCuentacontableComponent,
    template,
    bindings: {
      cuentaContable: '<',
    },
  })

function crearFragmento (valor, light) {
  var e = document.createElement('span')
  if (light) e.style.opacity = '0.6'
  e.textContent = valor
  return e
}

function crearHTML (cuentaContable) {
  var codeElement = document.createElement('code')

  cuentaContable.split('-')
    .map(function (parte) {
      return parte.replace(/^0*/g, function (match) {
        return ''.padStart(match.length, ' ')
      })
    })
    .forEach(function (parte, i, partes) {
      parte.split('')
        .forEach(function (n) {
          codeElement.append(crearFragmento((+n > 0 && n) || '0', n === ' '))
        })

      if ((i + 1) < partes.length) {
        codeElement.append(crearFragmento(' ', true))
      }
    })

  return codeElement
}

function ContabilidadPolizasCuentacontableComponent ($document, $element) {
  var $ctrl = this
  $ctrl.$onChanges = $onChanges

  $ctrl.cuentaContable = ''

  function $onChanges (changes) {
    if (changes.cuentaContable) {
      $element.empty()

      if ($ctrl.cuentaContable) {
        $element.append(crearHTML($ctrl.cuentaContable))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/cuentacontable/component.js